module.exports = __webpack_public_path__ + "static/media/CTLI_17-315w.36c6992a.png";